import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// production tips.
Vue.config.productionTip = false;
// ignore specific warn message.
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function(msg, vm, trace){
  if(msg === ignoreWarnMessage){
    msg = null, vm = null, trace = null;
    return { msg, vm, trace };
  }
};

// mount vue application.
new Vue({ router, store, vuetify, render: (h)=> h(App) }).$mount('#app');
